import { Inventory } from "@1games-ru/region-shared/dist/types/inventory/inventory";
import { intersection } from "lodash";
import { useMemo } from "react";
import useAppSelector from "@/core/helpers/useAppSelector";
import { OwnerType } from "@/domains/inventory/constants/ownerType";
import { InventoryState, inventoryMapSelector } from "@/domains/inventory/slice";

const getInventoryByOwnerType = (
  type: OwnerType,
  inventoryMap: InventoryState["inventoryMap"],
): Inventory | null => {
  let result = null;
  Object.keys(inventoryMap).forEach((key) => {
    if (inventoryMap[key].ownerType === type) {
      result = inventoryMap[key];
      return;
    }
  });

  return result;
};

export default function useConfiscationItems() {
  const inventoryMap = useAppSelector(inventoryMapSelector);
  const confiscationInventory = getInventoryByOwnerType(OwnerType.Confiscation, inventoryMap);
  const inventoryBag = getInventoryByOwnerType(OwnerType.Bag, inventoryMap);
  const inventoryCharacter = getInventoryByOwnerType(OwnerType.Character, inventoryMap);

  const disableItems = useMemo(() => {
    if (confiscationInventory && inventoryCharacter) {
      const result = confiscationInventory.items.map((item) => item.id);

      if (inventoryBag) {
        const bagItems = inventoryBag.items.map((item) => item.id);
        const confiscationBag = confiscationInventory.items.find(
          (item) => item.itemTemplate.type === OwnerType.Bag,
        );
        if (confiscationBag) {
          result.push(...bagItems);
        }
        if (intersection(result, bagItems).length) {
          const bag = inventoryCharacter.items.find(
            (item) => item.itemTemplate.type === OwnerType.Bag,
          );
          if (bag) {
            result.push(bag.id);
          }
        }
      }
      return result;
    }

    return [];
  }, [confiscationInventory, inventoryBag, inventoryCharacter]);

  return { disableItems, confiscationInventory };
}
